var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"image-crop"}},[_c('Croppie',{key:_vm.croppieKey,attrs:{"image":_vm.overlay.data.image,"size":_vm.size},on:{"crop":_vm.cropped,"cancel":function($event){return _vm.setOverlay()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }